// =============================================================================
// Calibration Procedure Types
// =============================================================================

export const PROCEDURE_TAGS = ['on-site', 'in-lab', 'Iso17025'] as const;

export interface MeasurementTemplate {
  measurand: string;
  target_measurement_uncertainty?: number;
}

/** Calibration procedure document from V4 API (PostgreSQL) */
export interface CalibrationProcedure {
  id: string;
  mongoProcedureId: string;
  accountId: string | null;
  accountName: string | null;
  name: string;
  description: string | null;
  dueDateMonths: number;
  calibratorIds: string[];
  tags: string[];
  measurementTemplates: MeasurementTemplate[];
  deletedAt: string | null;
  createdAt: string;
  updatedAt: string;
}

// =============================================================================
// Response Types
// =============================================================================

export interface CalibrationProceduresListResponse {
  calibrationProcedures: CalibrationProcedure[];
  total: number;
  page: number;
  pageLength: number;
}

// =============================================================================
// Filter Types
// =============================================================================

export interface CalibrationProcedureFilters {
  search?: string;
  deleted?: string;
  page?: number;
  pageLength?: number;
  sortKey?: string;
  sortDirection?: number;
}

// =============================================================================
// Input Types
// =============================================================================

export interface CreateCalibrationProcedureInput {
  name: string;
  due_date?: number;
  calibrators?: string[];
  tags?: string[];
  measurement_templates?: MeasurementTemplate[];
  description?: string;
}

export type UpdateCalibrationProcedureInput = Partial<CreateCalibrationProcedureInput>;
